import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { tenantWithFourthFooterLinkLists } from '@app/shared/constants';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  copyrightYear?: number;
  companyName?: string;
  hasFourthFooterLink: boolean = false;
  dsoName: string[] = tenantWithFourthFooterLinkLists;
  version = environment.version;
  get environment() {
    return environment;
  }

  constructor(private _router: Router) {}

  ngOnInit() {
    this.companyName = environment.tenantName;
    this.copyrightYear = new Date().getFullYear();
    this.hasFourthFooterLink = this.dsoName.includes(environment.tenant);
  }

  public goTo(): void {
    void this._router.navigate(['general-terms-of-use']);
  }
}
